module.exports = __webpack_public_path__ + "media/images/sp/stores/namba/namba_concept_02-f1a044717b0c6e27e6adb5d162f1490f.jpg";